import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { TipoTemplate } from 'src/app/models/tipo-template';
import { BaseEditForm } from 'src/app/shared/baseEditForm';


@Component({
  selector: 'tipi-template-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss']
})
export class TipiTemplateFormComponent extends BaseEditForm implements OnInit {

  tipoTemplate: TipoTemplate;
  form: FormGroup;
  constructor(private fb: FormBuilder,
    private toast: ToastrService,
    public dialogRef: MatDialogRef<TipiTemplateFormComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: TipoTemplate,) {
    super();
    this.tipoTemplate = data;
  }

  ngOnInit() {

    this.form = this.fb.group({
      nome: [this.tipoTemplate?.nome, Validators.required],
    });
  }

}

